<div class="u-text-align-center u-padding u-bordered u-w100p">
    <h1 class="__value">{{ value }}</h1>
    <p [innerHtml]="label"></p>
    <p class="u-color-muted u-font-size-small" [innerHtml]="subLabel"></p>
</div>
